// Tiempo relativo corto en español ("hace 3 min", "hace 2 h", "hace 4 d").
//
// Para instantes REALES (timestamptz serializado con zona), como
// `ultimo_latido_at`. No sirve para las horas "UTC falso" de la captura.

export function tiempoRelativo(iso: string | null | undefined, ahoraMs = Date.now()): string {
  if (!iso) return 'sin registro';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return 'sin registro';
  const seg = Math.max(0, Math.round((ahoraMs - t) / 1000));
  if (seg < 45) return 'hace unos segundos';
  const min = Math.round(seg / 60);
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) {
    const resto = min - h * 60;
    return resto > 0 && h < 6 ? `hace ${h} h ${resto} min` : `hace ${h} h`;
  }
  return `hace ${Math.floor(h / 24)} d`;
}
